import React, { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';
import {
  IconCheckBoxEmpty,
  IconCheckBoxFill,
  Text,
  Space,
} from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';

export const Checkbox = memo(
  ({
    size,
    value,
    title,
    onChange,
    textStyle,
    style,
    children,
    disabled,
    ...rest
  }) => {
    const { styles, colors } = useStyle();

    const { iconCheckedColor = colors.gray23, iconEmptyColor = colors.gray21 } =
      rest;

    const onPress = useCallback(() => {
      onChange && onChange(!value);
    }, [onChange, value]);

    return (
      <TouchableOpacity
        activeOpacity={0.7}
        {...{ onPress, disabled }}
        style={[styles.container, disabled && { opacity: 0.5 }, style]}
      >
        {value && <IconCheckBoxFill color={iconCheckedColor} />}
        {!value && <IconCheckBoxEmpty color={iconEmptyColor} />}
        {title && (
          <>
            <Space size={8} />
            <Text style={[styles.titleText, textStyle]}>{title}</Text>
          </>
        )}
        {children}
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleText: {
    fontSize: 14,
    color: colors.gray23,
  },
}));
